import { useEffect, useRef } from 'react'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { renderConversationItem } from './renderConversationItem'
import {
  ConversationProgressStubStyled,
  ConversationStreamListStyled,
} from './styles/ConversationStreamStyled'
import {
  type ConversationChoiceOption,
  type ConversationTurnItem,
} from '../../../../value-objects/ConversationTurnItem'

export interface IConversationStreamProps {
  items: ConversationTurnItem[]
  isStreaming: boolean
  onChoiceSelect: (option: ConversationChoiceOption) => void
}

export const ConversationStream = ({
  items,
  isStreaming,
  onChoiceSelect,
}: IConversationStreamProps) => {
  const intl = useProcurifyIntl()
  const feedRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const node = feedRef.current
    if (node) {
      node.scrollTop = node.scrollHeight
    }
  }, [items, isStreaming])

  if (items.length === 0 && !isStreaming) {
    return null
  }

  return (
    <ConversationStreamListStyled
      ref={feedRef}
      role='log'
      aria-live='polite'
      aria-label={intl.formatMessage(messages.feedAriaLabel)}
    >
      {items.map((item) => (
        <div key={item.id}>
          {renderConversationItem(item, { isStreaming, onChoiceSelect })}
        </div>
      ))}
      {isStreaming && (
        <ConversationProgressStubStyled
          role='status'
          aria-label={intl.formatMessage(messages.typing)}
        >
          …
        </ConversationProgressStubStyled>
      )}
    </ConversationStreamListStyled>
  )
}
